<template>
  <div>
    <v-row>
      <v-col class="d-flex flex-1 align-center justify-space-between">
        <span class="text-tcdc-green bold text-uppercase sub-header1">TCDC BANGKOK</span>
        <GreenLabel name="what's new" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <template v-for="item of 4">
          <div :key="item.toString()" class="py-10 venture-layout2-tcdc-border-green">
            <span class="text-tcdc-green sub-header2 bold">5th Floor</span>
            <v-row>
              <template v-for="item of 3">
                <v-col cols="12" md="4" :key="item.toString()">
                  <FloorCard title="Rooftop Garden"
                    content="Lorem ipsum dolor sit amet, coictetuer adipiscing elit, seddiam" />
                </v-col>
              </template>
            </v-row>
          </div>
        </template>
      </v-col>
    </v-row>
    <v-row class="mt-10">
      <v-col cols="12" md="10">
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col cols="12" md="10">
        <SendMessageForm @onSubmit="sendMsg" />
        <AlertModal :show="modal" :message="modalMsg" @onConfirm="modal = false"></AlertModal>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GreenLabel from "../../components/labels/GreenLabel";
import FloorCard from "../../components/cards/FloorCard";
import SendMessageForm from "../../components/form/SendMessageForm";
import AlertModal from "../modals/AlertModal";
import { mapState } from "vuex";

export default {
  components: {
    GreenLabel,
    FloorCard,
    SendMessageForm,
    AlertModal
  },
  data: () => ({
    modal: false,
    modalMsg: ''
  }),
  computed: {
    ...mapState({
      branch_id: state => state.Branch.branch_id
    })
  },
  methods: {
    sendMsg(form) {
      form.branch_id = this.branch_id;
      if (form.email && form.phone) {
        this.$store.dispatch('Contact/sendMsgVenueHire', form).then(() => {
          this.modalMsg = this.$t('messageBox.success');
          this.modal = true;
        });
      } else {
        this.modalMsg = this.$t('messageBox.notValid');
        this.modal = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.venture-layout2-tcdc-border-green {
  border-bottom: 2px solid $tcdcGreen;
  /* border-bottom: 2px solid orange; */
}

.venture-layout2-tcdc-border-green:last-child {
  border-bottom: 0px solid white !important;
}
</style>
